(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Dark ink footer surface, scoped via a class instead of a bare footer rule */
    var tzf = document.querySelector('.tzf');
    if (tzf) {
      var f = tzf.closest('footer');
      if (f) f.classList.add('tzf-root');
    }
    /* Hide the legacy utilities bar (replaced by this footer) */
    var u = document.querySelector('.trustripz-footer-utilities-surface');
    if (u) {
      var s = u.closest('.shopify-section');
      if (s) s.style.display = 'none';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-routine-bundle]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-routine-card]')];
    const available = cards.filter(card => !card.dataset.unavailable);
    const count = root.querySelector('[data-routine-count]');
    const countCopy = root.querySelector('[data-routine-count-copy]');
    const list = root.querySelector('[data-routine-selected]');
    const add = root.querySelector('[data-routine-add]');
    const label = root.querySelector('[data-routine-label]');
    const finePrint = root.querySelector('[data-routine-fine-print]');
    const subscriptionNote = root.querySelector('[data-routine-subscription-note]');
    let picked = [], target = 3, locked = [];
    const cardFor = handle => cards.find(card => card.dataset.productHandle === handle);
    const choice = () => root.querySelector('[data-routine-purchase]:checked').value;
    const setCard = (card, selected, fixed = false) => {
      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-fixed', fixed);
      card.querySelector('button').setAttribute('aria-pressed', selected ? 'true' : 'false');
    };
    const clear = () => { picked = []; locked = []; available.forEach(card => setCard(card, false)); };
    const addCard = (card, fixed = false) => {
      if (!card || card.dataset.unavailable || picked.some(item => item.handle === card.dataset.productHandle)) return;
      picked.push({ id: card.dataset.variantId, handle: card.dataset.productHandle, title: card.dataset.productTitle, plan: card.dataset.sellingPlan });
      if (fixed) locked.push(card.dataset.productHandle);
      setCard(card, true, fixed);
    };
    const render = () => {
      count.textContent = picked.length; countCopy.textContent = '/ ' + target + ' selected';
      add.disabled = picked.length !== target;
      list.innerHTML = picked.length ? '<ul>' + picked.map((item, index) => '<li><span>' + item.title + '</span>' + (locked.includes(item.handle) ? '<small>Included</small>' : '<button type="button" data-remove="' + index + '" aria-label="Remove ' + item.title + '">×</button>') + '</li>').join('') + '</ul>' : '<p>Choose any ' + target + ' strips to build your routine.</p>';
      const unsupported = picked.filter(item => !item.plan);
      subscriptionNote.hidden = choice() !== 'subscribe';
      subscriptionNote.textContent = unsupported.length ? 'Subscription delivery is currently being added for some strips in this routine. Eligible strips will follow the monthly plan.' : 'Monthly delivery selected. Your subscription savings will be applied at checkout.';
    };
    available.forEach(card => card.querySelector('button').addEventListener('click', () => {
      const handle = card.dataset.productHandle, position = picked.findIndex(item => item.handle === handle);
      if (position > -1) { if (locked.includes(handle)) return; picked.splice(position, 1); setCard(card, false); }
      else if (picked.length < target) addCard(card);
      render();
    }));
    list.addEventListener('click', event => { const remove = event.target.closest('[data-remove]'); if (!remove) return; const item = picked[Number(remove.dataset.remove)]; picked = picked.filter(candidate => candidate.handle !== item.handle); setCard(cardFor(item.handle), false); render(); });
    root.querySelectorAll('[data-routine-purchase]').forEach(input => input.addEventListener('change', () => { root.querySelectorAll('.routine-bundle__purchase-option').forEach(option => option.classList.toggle('is-selected', option.querySelector('input').checked)); render(); }));
    add.addEventListener('click', async () => {
      if (picked.length !== target) return;
      add.disabled = true; add.textContent = 'ADDING TO CART…';
      try {
        const subscribe = choice() === 'subscribe';
        const items = picked.map(item => { const line = { id: item.id, quantity: 1 }; if (subscribe && item.plan) line.selling_plan = item.plan; return line; });
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Unable to add your routine.');
        window.location.assign('/cart');
      } catch (error) { add.textContent = 'TRY AGAIN'; add.disabled = false; }
    });
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustripz-home-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('tz2-home');
    if (!root) return;

    /* Hide the theme header group on the homepage (fallback for browsers without :has) */
    var main = document.querySelector('main[data-template="index"]');
    if (main) document.body.classList.add('tz2-home');

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Product carousel — 3D coverflow */
    var carousel = root.querySelector('[data-tz2-pflow]');
    if (carousel) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tz2-pflow-card]'));
      var dotsWrap = root.querySelector('[data-tz2-pflow-dots]');
      var index = 0;

      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show product ' + (i + 1));
        b.addEventListener('click', function () { show(i); });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);

      function render() {
        cards.forEach(function (card, i) {
          var offset = i - index;
          if (offset > cards.length / 2) offset -= cards.length;
          if (offset < -cards.length / 2) offset += cards.length;
          card.setAttribute('data-pos', String(offset));
          card.setAttribute('aria-hidden', offset > 2 || offset < -2 ? 'true' : 'false');
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      function move(dir) {
        index = (index + dir + cards.length) % cards.length;
        render();
      }
      function show(i) {
        index = i;
        render();
        // On mobile the coverflow is a horizontal scroll row — bring the card into view
        if (window.matchMedia('(max-width: 900px)').matches && cards[index]) {
          cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
      root.querySelector('[data-tz2-pflow-prev]').addEventListener('click', function () { move(-1); });
      root.querySelector('[data-tz2-pflow-next]').addEventListener('click', function () { move(1); });
      carousel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') move(-1);
        if (e.key === 'ArrowRight') move(1);
      });

      /* drag/swipe */
      var startX = null;
      var stage = root.querySelector('[data-tz2-pflow-stage]');
      stage.addEventListener('pointerdown', function (e) { startX = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var delta = e.clientX - startX;
        startX = null;
        if (Math.abs(delta) > 40) move(delta < 0 ? 1 : -1);
      });
      /* native scroll (mobile) — sync the active dot with the centered card once scrolling settles.
         Touch swipes fire pointercancel (not pointerup), so the handler above never runs on touch;
         this keeps dots in sync without triggering the dot-driven scrollIntoView. */
      var pflowScrollTimer = null;
      stage.addEventListener('scroll', function () {
        if (!window.matchMedia('(max-width: 900px)').matches) return;
        if (pflowScrollTimer) clearTimeout(pflowScrollTimer);
        pflowScrollTimer = setTimeout(function () {
          var r = stage.getBoundingClientRect();
          var mid = r.left + r.width / 2;
          var best = index, bestD = Infinity;
          cards.forEach(function (card, i) {
            var b = card.getBoundingClientRect();
            var d = Math.abs((b.left + b.right) / 2 - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          if (best !== index) { index = best; render(); }
        }, 120);
      }, { passive: true });
      render();
    }

    /* Reviews — Zentia-style coverflow with blur + auto-advance */
    var ugc = root.querySelector('[data-tz2-ugc]');
    if (ugc) {
      var ugcStage = root.querySelector('[data-tz2-ugc-stage]');
      var ugcCards = Array.prototype.slice.call(root.querySelectorAll('[data-tz2-ugc-card]'));
      var ugcDotsWrap = root.querySelector('[data-tz2-ugc-dots]');
      var ugcDots = [];
      var ugcIndex = 0;
      var ugcPaused = false;
      var ugcTimer = null;

      ugcCards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show review ' + (i + 1));
        b.addEventListener('click', function () { ugcShow(i); });
        ugcDotsWrap.appendChild(b);
      });
      ugcDots = Array.prototype.slice.call(ugcDotsWrap.children);

      function ugcRender() {
        ugcCards.forEach(function (card, i) {
          var offset = i - ugcIndex;
          if (offset > ugcCards.length / 2) offset -= ugcCards.length;
          if (offset < -ugcCards.length / 2) offset += ugcCards.length;
          card.setAttribute('data-pos', String(offset));
          card.setAttribute('aria-hidden', offset > 2 || offset < -2 ? 'true' : 'false');
        });
        ugcDots.forEach(function (d, i) { d.classList.toggle('is-active', i === ugcIndex); });
      }
      function ugcShow(i) {
        ugcIndex = (i + ugcCards.length) % ugcCards.length;
        ugcRender();
      }
      root.querySelector('[data-tz2-ugc-prev]').addEventListener('click', function () { ugcShow(ugcIndex - 1); });
      root.querySelector('[data-tz2-ugc-next]').addEventListener('click', function () { ugcShow(ugcIndex + 1); });

      /* Auto-advance, paused on hover/focus/hidden tab, off for reduced motion */
      function ugcTick() {
        if (!ugcPaused && !document.hidden) ugcShow(ugcIndex + 1);
      }
      function ugcStart() {
        if (reducedMotion) return;
        ugcStop();
        ugcTimer = setInterval(ugcTick, 4200);
      }
      function ugcStop() {
        if (ugcTimer) { clearInterval(ugcTimer); ugcTimer = null; }
      }
      ugc.addEventListener('pointerenter', ugcStop);
      ugc.addEventListener('pointerleave', ugcStart);
      ugc.addEventListener('focusin', ugcStop);
      ugc.addEventListener('focusout', ugcStart);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) ugcStop(); else ugcStart();
      });
      ugcRender();
      ugcStart();
    }

    /* How-it-works cards — scroll-triggered staggered entrance (Q Active style) */
    var revealEls = Array.prototype.slice.call(root.querySelectorAll('[data-tz2-reveal]'));
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('is-in');
              io.unobserve(en.target);
            }
          });
        }, { threshold: 0.18 });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      }
    }

    /* Step progress bars — fill sequentially as the section scrolls (Q Active style) */
    var stepGrid = root.querySelector('[data-tz2-reveal-group]');
    if (stepGrid) {
      var stepFills = Array.prototype.slice.call(stepGrid.querySelectorAll('.tz2-step__fill'));
      function tz2Bars() {
        var r = stepGrid.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var p = (vh * 0.82 - r.top) / (r.height + vh * 0.3);
        p = Math.max(0, Math.min(1, p));
        stepFills.forEach(function (f, i) {
          var seg = Math.max(0, Math.min(1, p * stepFills.length - i));
          f.style.transform = 'scaleX(' + seg.toFixed(3) + ')';
        });
      }
      var tz2Scrollers = [window];
      var tz2Anc = stepGrid.parentElement;
      while (tz2Anc && tz2Anc !== document.body) {
        var tz2St = getComputedStyle(tz2Anc);
        if (/(auto|scroll)/.test(String(tz2St.overflowY) + String(tz2St.overflow))) tz2Scrollers.push(tz2Anc);
        tz2Anc = tz2Anc.parentElement;
      }
      tz2Scrollers.forEach(function (s) { s.addEventListener('scroll', tz2Bars, { passive: true }); });
      /* Capture-phase listener: scroll events don't bubble, but document-level capture catches any scroller */
      document.addEventListener('scroll', tz2Bars, { passive: true, capture: true });
      window.addEventListener('resize', tz2Bars);
      tz2Bars();
    }

    /* Offer popup — Zentia-style timing, only the verified B2G1 offer */
    var pp = document.getElementById('tz2-pp');
    if (pp) {
      var PP_KEY = 'tz2_pp_dismissed', PP_SUB = 'tz2_pp_subscribed', PP_SEEN = 'tz2_pp_seen';
      var PP_MIN = 7000, PP_MOBILE = 10000, PP_DAYS = 3;
      var ppStore = {
        get: function (s, k) { try { return s.getItem(k); } catch (e) { return null; } },
        set: function (s, k, v) { try { s.setItem(k, v); } catch (e) {} }
      };
      var ppShown = false, ppLastFocus = null, ppScrollWrap = document.querySelector('.page-wrapper');
      var ppIsMobile = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
      ppStore.set(sessionStorage, PP_SEEN, '0');

function ppBlocked() {
  return ppStore.get(localStorage, PP_SUB) === 'true'
    || ppStore.get(sessionStorage, PP_SEEN) === '1';
}

 function ppOpen(markSeen) {
        if (ppShown) return;
        ppShown = true;
        pp.hidden = false;
        if (markSeen !== false) ppStore.set(sessionStorage, PP_SEEN, '1');
        document.documentElement.classList.add('tz2-pp-lock');
        if (ppScrollWrap) ppScrollWrap.style.overflow = 'hidden';
        ppLastFocus = document.activeElement;
        var closeBtn = pp.querySelector('.tz2-pp__close');
        if (closeBtn) closeBtn.focus();
      }
      function ppClose() {
        if (!ppShown) return;
        ppShown = false;
        pp.hidden = true;
        ppStore.set(localStorage, PP_KEY, String(Date.now()));
        document.documentElement.classList.remove('tz2-pp-lock');
        if (ppScrollWrap) ppScrollWrap.style.overflow = '';
        if (ppLastFocus && ppLastFocus.focus) ppLastFocus.focus();
      }
      /* Re-check dismissal state at trigger time — dismissal during the same page must stick */
      function ppTryOpen() { if (!ppBlocked()) ppOpen(); }
      /* Close controls */
      pp.querySelectorAll('[data-tz2-pp-close]').forEach(function (b) {
        b.addEventListener('click', ppClose);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ppShown) ppClose();
        /* Simple focus trap: keep Tab cycling inside the open dialog */
        if (e.key === 'Tab' && ppShown) {
          var focusables = pp.querySelectorAll('button, a[href], input');
          if (!focusables.length) return;
          var list = Array.prototype.filter.call(focusables, function (f) { return f.offsetParent !== null && !f.disabled; });
          if (!list.length) return;
          var first = list[0], last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      /* After a real newsletter submit, the server re-renders the form state — reopen with it */
      if (pp.querySelector('[data-tz2-pp-ok]')) {
        ppStore.set(localStorage, PP_SUB, 'true');
        ppOpen(false);
      } else if (pp.querySelector('[data-tz2-pp-err]')) {
        ppOpen(false);
      } else if (!ppBlocked()) {
        /* Timed show: 7s desktop, 10s mobile; exit-intent on desktop */
        var ppTimer = setTimeout(function () { ppTryOpen(); }, ppIsMobile ? PP_MOBILE : PP_MIN);
        if (!ppIsMobile) {
          document.addEventListener('mouseout', function ppExit(e) {
            if (!e.relatedTarget && e.clientY <= 8) { clearTimeout(ppTimer); ppTryOpen(); }
          });
        }
      }
    }

    /* Mobile menu */
    var menuBtn = root.querySelector('[data-tz2-menu-btn]');
    var header = root.querySelector('[data-tz2-header]');
    if (menuBtn && header) {
      function closeMenu() {
        header.classList.remove('is-open');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.setAttribute('aria-label', 'Open menu');
      }
      menuBtn.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      /* Close the mobile menu after an anchor is chosen */
      var mobileNav = root.querySelector('[data-tz2-mobile-nav]');
      if (mobileNav) {
        mobileNav.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', closeMenu);
        });
      }
    }

    /* Our Strips dropdowns (desktop nav + mobile drawer) */
    var navdd = root.querySelector('[data-tz2-navdd]');
    if (navdd) {
      var navddBtn = navdd.querySelector('.tz2-navdd__btn');
      function closeNavdd() {
        navdd.classList.remove('is-open');
        navddBtn.setAttribute('aria-expanded', 'false');
      }
      navddBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = navdd.classList.toggle('is-open');
        navddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) { if (!navdd.contains(e.target)) closeNavdd(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNavdd(); });
      navdd.querySelectorAll('.tz2-navdd__menu a').forEach(function (a) {
        a.addEventListener('click', closeNavdd);
      });
    }
    var mobiledBtn = root.querySelector('[data-tz2-mobile-dd]');
    if (mobiledBtn) {
      var mobiledMenu = root.querySelector('[data-tz2-mobile-ddmenu]');
      mobiledBtn.addEventListener('click', function () {
        var open = mobiledMenu.classList.toggle('is-open');
        mobiledBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Hero slideshow — crossfade background (like Draft 01) */
    var heroShow = root.querySelector('[data-tz2-hero-slideshow]');
    if (heroShow) {
      var slides = Array.prototype.slice.call(heroShow.querySelectorAll('[data-tz2-slide]'));
      var heroControls = Array.prototype.slice.call(heroShow.querySelectorAll('[data-tz2-hero-control]'));
      var heroIndex = 0, heroTimer = null;
      var heroUserPaused = false, heroHover = false, heroFocus = false;
      function goHero(n) {
        if (n === heroIndex) return;
        heroIndex = (n + slides.length) % slides.length;
        slides.forEach(function(s, i) {
          var on = i === heroIndex;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if ('inert' in s) s.inert = !on;
        });
        heroControls.forEach(function(c, i) { c.classList.toggle('is-active', i === heroIndex); });
      }
      slides.forEach(function(s, i) { if ('inert' in s) s.inert = i !== 0; });
      function heroSchedule() {
        if (heroTimer) { clearTimeout(heroTimer); heroTimer = null; }
        if (reducedMotion || heroUserPaused || heroHover || heroFocus || document.hidden || slides.length < 2) return;
        heroTimer = setTimeout(function() { goHero(heroIndex + 1); heroSchedule(); }, 6500);
      }
      heroControls.forEach(function(c, i) {
        c.addEventListener('click', function() { goHero(i); heroSchedule(); });
      });
      heroShow.addEventListener('mouseenter', function() { heroHover = true; heroSchedule(); });
      heroShow.addEventListener('mouseleave', function() { heroHover = false; heroSchedule(); });
      heroShow.addEventListener('focusin', function() { heroFocus = true; heroSchedule(); });
      heroShow.addEventListener('focusout', function(e) {
        if (!heroShow.contains(e.relatedTarget)) { heroFocus = false; heroSchedule(); }
      });
      var pauseBtn = heroShow.querySelector('[data-tz2-hero-pause]');
      if (pauseBtn) {
        pauseBtn.addEventListener('click', function() {
          heroUserPaused = !heroUserPaused;
          pauseBtn.classList.toggle('is-paused', heroUserPaused);
          pauseBtn.setAttribute('aria-pressed', heroUserPaused ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', heroUserPaused ? 'Play slideshow' : 'Pause slideshow');
          heroSchedule();
        });
      }
      heroSchedule();
      document.addEventListener('visibilitychange', function() { heroSchedule(); });
    }

    /* One tin, one month — tin supply calendar auto-fill (Q Active style) */
    var month = root.querySelector('[data-tz2-month]');
    if (month && !month.dataset.tz2Ready) {
      month.dataset.tz2Ready = 'true';
      var cells = Array.prototype.slice.call(month.querySelectorAll('.tz2-month__cell'));
      var dayEl = month.querySelector('[data-tz2-month-day]');
      var badge = month.querySelector('.tz2-month__badge');
      var mday = 0, mtimer = null;
      function renderMonth() {
        if (dayEl) dayEl.textContent = mday;
        cells.forEach(function(c, i) { c.classList.toggle('is-filled', i < mday); });
        if (badge) badge.classList.toggle('is-done', mday >= 30);
      }
      function monthStep() {
        mday = mday >= 30 ? 0 : mday + 1;
        renderMonth();
        mtimer = setTimeout(monthStep, mday === 30 ? 3400 : (mday === 0 ? 900 : 130));
      }
      if (reducedMotion) { mday = 30; renderMonth(); }
      else if ('IntersectionObserver' in window) {
        var monthIO = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) { if (!mtimer) monthStep(); }
            else if (mtimer) { clearTimeout(mtimer); mtimer = null; }
          });
        }, { threshold: 0.3 });
        monthIO.observe(month);
      } else { monthStep(); }
    }

    /* FAQ: one open at a time */
    var faqItems = root.querySelectorAll('.tz2-faq__item');
    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) faqItems.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });

    /* First-order offer — live countdown; when the WELCOME code really expires, stop advertising it */
    var offerEnd = Date.parse('2026-11-12T04:59:59Z');
    var cdNodes = root.querySelectorAll('[data-tz2-countdown]');
    if (!isNaN(offerEnd)) {
      var cdTimer = null;
      function cdRender() {
        var left = offerEnd - Date.now();
        var over = left <= 0;
        root.classList.toggle('tz2-offer-ended', over);
        if (over) { if (cdTimer) { clearInterval(cdTimer); cdTimer = null; } return; }
        var sec = Math.floor(left / 1000);
        var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60);
        cdNodes.forEach(function (n) { n.textContent = d + 'd ' + h + 'h ' + m + 'm'; });
      }
      cdRender();
      cdTimer = setInterval(cdRender, 30000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) cdRender(); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustripz-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousel = document.querySelector('[data-hero-carousel]');
    if (!carousel || carousel.dataset.ready) return;

    carousel.dataset.ready = 'true';
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const controls = [...carousel.querySelectorAll('[data-hero-control]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;

    const showSlide = (index) => {
      activeIndex = index;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      controls.forEach((control, controlIndex) => {
        const active = controlIndex === activeIndex;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-pressed', String(active));
      });
    };

    const startAutoplay = () => {
      if (reducedMotion) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => showSlide((activeIndex + 1) % slides.length), 6500);
    };

    controls.forEach((control, index) => control.addEventListener('click', () => {
      showSlide(index);
      startAutoplay();
    }));

    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', startAutoplay);
    showSlide(0);
    startAutoplay();

    const science = document.querySelector('[data-science-carousel]');
    if (!science || science.dataset.ready) return;

    science.dataset.ready = 'true';
    const scienceSlides = [...science.querySelectorAll('[data-science-slide]')];
    const scienceControls = [...science.querySelectorAll('[data-science-control]')];
    const scienceStage = science.querySelector('.trustripz-home__science-stage');
    const sciencePrevious = science.querySelector('[data-science-previous]');
    const scienceNext = science.querySelector('[data-science-next]');
    let scienceIndex = 0;
    let scienceTimer;
    let sciencePointerStart = null;

    const showScienceSlide = (index) => {
      scienceIndex = index;
      scienceSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === scienceIndex;
        const position = (slideIndex - scienceIndex + scienceSlides.length) % scienceSlides.length;
        slide.classList.toggle('is-active', active);
        slide.dataset.position = position === 0 ? 'active' : position === 1 ? 'next' : 'previous';
        slide.setAttribute('aria-hidden', String(!active));
      });
      scienceControls.forEach((control, controlIndex) => {
        const active = controlIndex === scienceIndex;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-pressed', String(active));
      });
    };

    const startScienceAutoplay = () => {
      if (reducedMotion) return;
      window.clearInterval(scienceTimer);
      scienceTimer = window.setInterval(() => showScienceSlide((scienceIndex + 1) % scienceSlides.length), 5200);
    };

    scienceControls.forEach((control, index) => control.addEventListener('click', () => {
      showScienceSlide(index);
      startScienceAutoplay();
    }));

    const moveScience = (direction) => {
      showScienceSlide((scienceIndex + direction + scienceSlides.length) % scienceSlides.length);
      startScienceAutoplay();
    };

    sciencePrevious?.addEventListener('click', () => moveScience(-1));
    scienceNext?.addEventListener('click', () => moveScience(1));

    if (scienceStage) {
      scienceStage.addEventListener('pointerdown', (event) => {
        sciencePointerStart = event.clientX;
        scienceStage.classList.add('is-dragging');
        scienceStage.setPointerCapture?.(event.pointerId);
      });

      const completeScienceGesture = (event) => {
        if (sciencePointerStart === null) return;
        const delta = event.clientX - sciencePointerStart;
        sciencePointerStart = null;
        scienceStage.classList.remove('is-dragging');
        if (Math.abs(delta) > 42) moveScience(delta < 0 ? 1 : -1);
      };

      scienceStage.addEventListener('pointerup', completeScienceGesture);
      scienceStage.addEventListener('pointercancel', () => {
        sciencePointerStart = null;
        scienceStage.classList.remove('is-dragging');
      });
    }

    science.addEventListener('mouseenter', () => window.clearInterval(scienceTimer));
    science.addEventListener('mouseleave', startScienceAutoplay);
    showScienceSlide(0);
    startScienceAutoplay();
  })();

  } catch(e) { console.error(e); }
})();
})();
